import React, { lazy, Suspense, useState } from 'react';
import { fha203kProgramName, foreignNationalProgramName } from '../Utils/WHL/helpers';
import { Loader } from './Loader';
import useContent from '../Utils/useContent';

const FHAPage = lazy(() => import('../pages/fha-page/index'));
const VAPage = lazy(() => import('../pages/va-page/index'));
const USDAPage = lazy(() => import('../pages/usda-page/index'));
const ConvPage = lazy(() => import('../pages/conv-page/index'));
const HECMPage = lazy(() => import('../pages/hecm-page/index'));
const Fha203kPage = lazy(() => import('../pages/fha-203K-page'));



const WhlPageWrapper = ({
    pageDetails, data, props
}) => {

    const { pageName } = pageDetails

    if (data===null) {
        return (<p>Loading...</p>)
    }


    return <>
        {
            pageName === 'FHA' && <>
                <Suspense fallback={<Loader />}>
                    <FHAPage pageDetails={pageDetails} data={data} props={props}/>
                </Suspense>
            </>
        }
        {
            pageName === 'VA' && <>
                <Suspense fallback={<Loader />}>
                    <VAPage pageDetails={pageDetails} data={data} />
                </Suspense>
            </>
        }
        {
            pageName === 'USDA' && <>
                <Suspense fallback={<Loader />}>
                    <USDAPage pageDetails={pageDetails} data={data} />
                </Suspense>
            </>
        }
        {
            pageName === 'Conventional' && <>
                <Suspense fallback={<Loader />}>
                    <ConvPage pageDetails={pageDetails} data={data}/>
                </Suspense>
            </>
        }
        {
            pageName === 'HECM' && <>
                <Suspense fallback={<Loader />}>
                    <HECMPage pageDetails={pageDetails} data={data} />
                </Suspense>
            </>
        }
        {
            pageName === fha203kProgramName && <>
                <Suspense fallback={<Loader />}>
                    <Fha203kPage pageDetails={pageDetails} data={data} />
                </Suspense>
            </>
        }
    </>

}

export default WhlPageWrapper;
